import { render, staticRenderFns } from "./sendsuccess.vue?vue&type=template&id=25768915&"
import script from "./sendsuccess.vue?vue&type=script&lang=js&"
export * from "./sendsuccess.vue?vue&type=script&lang=js&"
import style0 from "./sendsuccess.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports